import { render, staticRenderFns } from "./TemplateSelector.vue?vue&type=template&id=4c31f079&scoped=true"
import script from "./TemplateSelector.vue?vue&type=script&lang=js"
export * from "./TemplateSelector.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelector.vue?vue&type=style&index=0&id=4c31f079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c31f079",
  null
  
)

export default component.exports